import { Component, HostListener } from '@angular/core';
import { Platform } from '@ionic/angular';
// import {Plugins} from "@capacitor/core/dist";
// const {SplashScreen} = Plugins;

import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
//import { PrivacyScreen } from '@capacitor-community/privacy-screen';
import { Capacitor } from '@capacitor/core';
import { NgZone } from '@angular/core';
import { Common, logger } from './Module/Shared/Utility/Common';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from './Module/Shared/Service/Navigation.service';
//import { SplashScreen } from '@capacitor/splash-screen';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private history: string[] = [];
  constructor(private navigation: NavigationService, private _location: Location, private router: Router, public plt: Platform) {
    if (environment.production) {
      logger.disableLogger();
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });

    // if (environment.production) {
    //   //console.log = function () { };

    // }
    this.plt.backButton.subscribeWithPriority(-1, () => {
      //  console.log("this._location",))
      if (this._location.path().indexOf('/user/dashboard') != -1) {
        App.exitApp();
      } else {
        this.navigation.back();
      }
    });

  }

  async ngOnInit() {
    this.plt.ready().then(async(readySource) => {

      if (Capacitor.platform === 'web') {
      } else {

       //  SplashScreen.show();
       // SplashScreen.show({ autoHide: false });

        StatusBar.setOverlaysWebView({ overlay: false });
        StatusBar.setBackgroundColor({
          color: '#19365F',
        });
 // setTimeout(() => { console.log("init"); SplashScreen.hide(); }, 1000);
      }
    });
  }

}
